
// Third Party
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ConfirmationMessage, enumMessageType } from '@/store/types';
import { namespace } from 'vuex-class';

// Types
import { Map } from "@/store/map-setup/types";

// Sv Components
import MapManagementModal from "@/components/map-setup/MapManagementModal.vue";
import ConfirmationModal from "@/components-shared/ConfirmationModal.vue";

// Namespaces
const MapSetupStore = namespace("mapSetup");

@Component({
	components: {
		"map-management-modal": MapManagementModal,
        "confirmation-modal": ConfirmationModal,
	}
})
export default class MapManagement extends Vue {
    // -- Props -- //
    @Prop({ default: 0, type: Number }) groupId: number;

    // -- Vuex -- //
    @MapSetupStore.State notificationOptions!: NotificationOptions;

	@MapSetupStore.Action loadUnconvertedMaps: (groupId: number) => Promise<void>;
    @MapSetupStore.Action deleteMap: (mapId: number) => Promise<void>;

    @MapSetupStore.Mutation("setNotificationOptions") private setNotificationOptions: (
		notificationOptions: NotificationOptions
	) => void;

    // -- Properties -- //
    private mapToDelete: Map | null = null;
    private modalVisible: boolean = false;
    private confirmationModalVisible: boolean = false;
    private isLoading: boolean = false;

    // -- Watchers -- //
    @Watch("notificationOptions")
    public onNotificationOptionsChanged(notificationOptions: NotificationOptions)
    {
        if (!notificationOptions) {
			return;
		}

		this.$notify(notificationOptions);
		this.setNotificationOptions(null);
    }

    // -- Computer Properties -- //
    private get confirmationMessageString(): string
    {
        return `Are you sure you wish to delete "${this.mapToDelete?.title}"?`;
    }

    private get confirmationMessage(): ConfirmationMessage
    {
        return {
            messageType: enumMessageType.confirmation,
            text: this.confirmationMessageString
        }
    }

    private async displayModal(): Promise<void>
    {
        this.isLoading = true;
        this.modalVisible = true;

        await this.loadUnconvertedMaps(this.groupId);

        this.isLoading = false;
    }

    private onDisplayConfirmation(maptoDelete: Map)
    {
        this.mapToDelete = maptoDelete;
        this.confirmationModalVisible = true;
    }

    private async onDeleteMap(): Promise<void>
    {
        if (!this.mapToDelete)
        {
            return;
        }

        this.isLoading = true;

        await this.deleteMap(this.mapToDelete.mapID);

        this.confirmationModalVisible = false;
        this.isLoading = false;
    }

    private onCancelConfirmation(): void
    {
        this.confirmationModalVisible = false;
        this.mapToDelete = null;
    }

    private onCancel(): void
    {
        this.modalVisible = false;
        this.mapToDelete = null;
    }

    private convertMap(mapToConvert: Map): void 
    {
        this.$emit("convert-map", mapToConvert);
    }
}
